<template>
  <div class="editor-context-container">
    <div class="d-flex">
      <v-icon style="padding-top: 2px;" class="align-start" :size="20">
        title
      </v-icon>
      <EditableSpan
        style="width: 80%;"
        class="reflection-title"
        :editable="!reflectionReadOnly"
        :initial-content="reflection.title"
        @contentUpdated="titleUpdated"
        :ellipsis-when-shown="false"
      />
    </div>
    <div class="d-flex">
      <v-icon style="padding-top: 2px;" class="align-start" :size="20">
        description
      </v-icon>
      <EditableSpan
        style="width: 80%;"
        class="reflection-description"
        :editable="!reflectionReadOnly"
        :initial-content="reflection.description !== null ? reflection.description : ''"
        @contentUpdated="descriptionUpdated"
        :ellipsis-when-shown="false"
      />
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { types } from '../../../../store/rootTypes';
import EditableSpan from '../EditableSpan';

export default {
  name: 'EditorContext',
  components: { EditableSpan },
  props: {
    reflection: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      reflectionReadOnly: types.reflections.getters.reflectionReadOnly,
    }),
  },
  methods: {
    ...mapActions({
      updateReflection: types.reflections.actions.updateReflection,
    }),
    titleUpdated(updatedValue) {
      const updateObject = {
        reflectionId: this.reflection.id,
        updateData: {
          title: updatedValue,
        },
      };

      this.updateReflection(updateObject);
    },
    descriptionUpdated(updatedValue) {
      const updateObject = {
        reflectionId: this.reflection.id,
        updateData: {
          description: updatedValue,
        },
      };

      this.updateReflection(updateObject);
    },
  },
};
</script>
<style scoped>
.editor-context-container {
  width: 816px;
}
.reflection-title {
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
}
.reflection-description {
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
}
</style>
